import React from "react";
import { Grid, InputAdornment } from "@material-ui/core";
import { ThemeType } from "@theme";
import { PlainLink } from "@components";
import TextField from "@components/form_fields/TextField";
import { Small } from "@components/typography/Small";
import { makeStyles } from "@material-ui/core/styles";

export type TextEditorData = {
  from: string;
  to: string;
  message: string;
};

export type TextEditorTemplate = {
  id: string;
  title: string;
  content: string;
};

export type TextEditorProps = {
  isFromReadonly?: boolean;
  isToReadonly?: boolean;
  showFrom?: boolean;
  showTo?: boolean;
  getMessageLength?: () => string;
  onTemplateSelect?: (tpl: TextEditorTemplate) => any;
  templates?: TextEditorTemplate[];
};

export function TextEditor(props: TextEditorProps) {
  const classes = useStyles({});
  const { getMessageLength, isFromReadonly, isToReadonly, showFrom, showTo, templates } =
    props;

  return (
    <Grid container direction="column" spacing={2} className={classes.root}>
      {showFrom && (
        <Grid item>
          <TextField name="from" label="From" fullWidth disabled={isFromReadonly} />
        </Grid>
      )}

      {showTo && (
        <Grid item>
          <TextField name="to" label="To" fullWidth multiline disabled={isToReadonly} />
        </Grid>
      )}

      <Grid item>
        <TextField
          label="Message"
          name="message"
          multiline
          fullWidth
          InputProps={{
            endAdornment: getMessageLength ? (
              <InputAdornment className={classes.counter} position="end">
                {getMessageLength()}
              </InputAdornment>
            ) : null
          }}
        />
      </Grid>

      {templates.length > 0 && (
        <Grid item className={classes.quick}>
          <Small>Quick text:</Small>
          {templates.slice(0, 3).map((template) => (
            <PlainLink
              dashed
              size="small"
              key={template.id}
              onClick={() => props.onTemplateSelect && props.onTemplateSelect(template)}
            >
              {template.title}
            </PlainLink>
          ))}
        </Grid>
      )}

      <Grid item />
    </Grid>
  );
}

TextEditor.defaultProps = {
  showFrom: true,
  showTo: true,
  templates: []
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {},

  quick: {
    // display: "flex",
    "& > a": {
      display: "inline-block",
      marginRight: theme.spacing()
    }
  },

  counter: {
    position: "absolute",
    bottom: -20,
    right: 0
  }
}));
